import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  templateUrl: './loader.component.html',
  styleUrls: ['./loader.component.scss'],
})
export class LoaderComponent implements OnInit {
  visible: string;
  text: string;
  private subscription: Subscription;

  constructor(private readonly loader: LoaderService) {
    this.text = '';
    this.visible = '';
    this.subscription = new Subscription();
  }

  ngOnInit() {
    this.subscription.add(
      this.loader.getProgress().subscribe((load) => {
        if (load.includes('#')) {
          this.visible = load.split('#')[0];
          this.text = load.split('#')[1];
        } else {
          this.visible = load;
        }
      })
    );
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
